/* Quick add — a size button on a product card puts that pair straight in the bag.
   Used by the shoppable article shelves (snippets/shop-rail.liquid →
   product-card with quick_add). One delegated listener; theme.cart.add
   (cart-store.js) does the request and component-cart.js opens the drawer on
   'add', exactly as the product page's own button does — there is no second
   add-to-cart path to keep in step.

   The size picked here also seeds size memory (component-size-memory.js) when
   nothing is stored yet, so the shopper's number is inked on the next grid. */
(function () {
  if (window.__ssQuickAdd) { return; }
  window.__ssQuickAdd = true;

  function notify(msg) {
    var toast = document.getElementById('toast');
    var toastMsg = document.getElementById('toastMsg');
    if (!toast || !toastMsg || !msg) { return; }
    toastMsg.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(notify._t);
    notify._t = setTimeout(function () { toast.classList.remove('is-on'); }, 2400);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) { return; }
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true' || !window.theme || !theme.cart) { return; }

    var size = btn.getAttribute('data-size');
    if (size) {
      try { if (!localStorage.getItem('ss:size')) { localStorage.setItem('ss:size', size); } } catch (err) {}
    }

    btn.setAttribute('aria-busy', 'true');
    var item = { id: Number(btn.getAttribute('data-quick-add')), quantity: 1 };
    var plan = btn.getAttribute('data-selling-plan');
    if (plan) { item.selling_plan = Number(plan); }
    theme.cart.add([item])
      .then(function () {
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
      })
      .catch(function (err) {
        notify((err && err.userMessage) || theme.t('product.add_error'));
      })
      .then(function () { btn.removeAttribute('aria-busy'); });
  });
})();
